import axios from "axios"
import { ResponseRequestGeneric } from "components/Types/GeneralTypes"
import configData from "config.json"
import { authHeader } from "helpers/auth-header"
import { solicitudesPersonas, persona, InfoPersonasHE } from './typesAsignarCur'

import { hadleAxiosErrorResponse } from "helpers/handle-response"
import { number } from "yargs"
import { GetDateObjectFromIsoFormat, ObtenerFechaFromIsoFormat } from "../../../../functions/DatesFunctions"
import { Data } from "@react-google-maps/api"
import { downloadExcelReport } from "../../../../helpers/downloadExcelReport"


const URL_CONTROLLER_TABLA_INFO_CUR = `${configData.SERVER_URL}AsignacionTalentoHumano`    

const URL_CONTROLLER_TABLA_PRESENTAR = `${URL_CONTROLLER_TABLA_INFO_CUR}/InformacionTablasHE/`

const URL_CONTROLLER_INFO_ACTUALIZAR = `${URL_CONTROLLER_TABLA_INFO_CUR}/ActualizarTablaHE/`

const URL_CONTROLLER_TABLA_CUR = `${URL_CONTROLLER_TABLA_INFO_CUR}/InformacionTablaporCUR/`

const URL_CONTROLLER_TABLA_COMPLETA_CUR = `${URL_CONTROLLER_TABLA_INFO_CUR}/InformacionCURdatosCompletos/`

const URL_CONTROLLER_CUR_SINGULARES = `${URL_CONTROLLER_TABLA_INFO_CUR}/TablaCurs`

const URL_CONTROLLER_CUR_HISTORIAL = `${URL_CONTROLLER_TABLA_INFO_CUR}/TablaCursHistorial`

export async function informacionTablaHE(anio: number, mes: number) {
    var respuesta: ResponseRequestGeneric<InfoPersonasHE[]> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${URL_CONTROLLER_TABLA_PRESENTAR}${anio}/${mes}`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: InfoPersonasHE[] | undefined = responseAxios.data;
        
        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }

    }
    catch(error) {
        respuesta = hadleAxiosErrorResponse<InfoPersonasHE[]>(error)
    }
    return respuesta
    
}

export async function informacionTablaHEporCUR(cur: number) {
    var respuesta: ResponseRequestGeneric<InfoPersonasHE[]> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${URL_CONTROLLER_TABLA_CUR}${cur}`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        //var data: InfoPersonasHE[] | undefined = responseAxios.data;

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }

    }
    catch (error) {
        respuesta = hadleAxiosErrorResponse<InfoPersonasHE[]>(error)
    }
    return respuesta

}

export async function informacionCompletaTablaCUR(cur: number) {
    var respuesta: ResponseRequestGeneric<InfoPersonasHE[]> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${URL_CONTROLLER_TABLA_COMPLETA_CUR}${cur}`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        //var data: InfoPersonasHE[] | undefined = responseAxios.data;

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }

    }
    catch (error) {
        respuesta = hadleAxiosErrorResponse<InfoPersonasHE[]>(error)
    }
    return respuesta
}

export async function tablaCurSingular() {
    var respuesta: ResponseRequestGeneric<number[]> = {
        status: -1
    }
    try {
        const responseAxios = await axios.get(URL_CONTROLLER_CUR_SINGULARES, {
            headers: authHeader()
        })

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }
    }
    catch (error) {
        respuesta = hadleAxiosErrorResponse<number[]>(error)
    }
    return respuesta
}

export async function tablaCurHistorial() {
    var respuesta: ResponseRequestGeneric<number[]> = {
        status: -1
    }
    try {
        const responseAxios = await axios.get(URL_CONTROLLER_CUR_HISTORIAL, {
            headers: authHeader()
        })

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }
    }
    catch (error) {
        respuesta = hadleAxiosErrorResponse<number[]>(error)
    }
    return respuesta
}

export async function ActualizarInfoTabla(nuevaInformacion: InfoPersonasHE[]) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {
        
        const requestActulizar = {
            listado: nuevaInformacion
        }

        const responseAxios = await axios.post(URL_CONTROLLER_INFO_ACTUALIZAR, requestActulizar, {
            headers: authHeader()

        });

        respuesta = {
            
            status: responseAxios.status,
            dataResponse: responseAxios.data,
        }

    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}

export async function obtenerReporteExcelPHEporPagar(cur: number) {

    const url = `AsignacionTalentoHumano/ReportePagoHorasExtrasPP/${cur}`
    await downloadExcelReport(url, "REPORTE PAGOS HORAS EXTRAS.xlsx")
}

export async function obtenerReporteExcelPHEasignacionFecha(cur: number) {

    const url = `AsignacionTalentoHumano/ReportePagoHorasExtrasAF/${cur}`
    await downloadExcelReport(url, "REPORTE PAGOS HORAS EXTRAS SIN FECHA DE PAGO.xlsx")
}